import shop from "@/api/stockDetails";
// initial state
const state = {
  all: [],
  Stock: {},
  selectedStockDetails: []
};
// getters
const getters = {
  Stock: state => {
    return state.Stock;
  }
};

// actions
const actions = {
  getAllStockDetails({ commit }) {
    shop.getStockDetails().then(StockDetails => {
      commit("getStockDetails", StockDetails.data);
    });
  },
  searchStock: async (context, Stock) => {
    let d = (await shop.searchStock(Stock)).data;
    context.commit("getStockDetails", d);
    return d;
  },
  getStock: async (context, id) => {
    let d = (await shop.getStock(id)).data;
    context.commit("getStock", d);
    return d;
  },
  postStock: async (context, Stock) => {
    const result = (await shop.postStock(Stock)).data;
    context.commit("postStock", result);
  },
  putStock: async (context, Stock) => {
    const result = (await shop.putStock(Stock)).data;
    context.commit("putStock", result);
  },
  deleteStock: async (context, Stock) => {
    const result = (await shop.deleteStock(Stock)).data;
    // eslint-disable-next-line no-console
    console.log(result);
    context.commit("deleteStock", Stock);
  },
  bulkUpdateStates: async (context, model) => {
    const result = (await shop.bulkUpdateStates(model)).data;
    // eslint-disable-next-line no-console
    context.commit("bulkUpdateStates", model);
  }
};

// mutations
const mutations = {
  getStockDetails(state, StockDetails) {
    state.all = StockDetails;
  },
  setSelectedStockDetails(state, StockDetails) {
    state.selectedStockDetails = StockDetails;
  },
  getStock(state, Stock) {
    //state.Stock = Stock
    state.Stock = null;
    state.Stock = Object.assign({}, state.Stock, Stock);
  },
  postStock(state, Stock) {
    //state.Stock = Stock
    state.Stock = null;
    state.Stock = Object.assign({}, state.Stock, Stock);
  },
  putStock(state, Stock) {
    //state.Stock = Stock
    state.Stock = null;
    state.Stock = Object.assign({}, state.Stock, Stock);
  },
  deleteStock(state, Stock) {
    state.all.splice(state.all.indexOf(Stock), 1);
  },
  bulkUpdateStates(state, model) {
    // const data = model.selecteItems.map(({ id }) => id);
    state.all = Object.assign({}, state.all, model);

    // state.all.splice(state.all.indexOf(Stock), 1);
  },
  decrementStockInventory(state, { id }) {
    const Stock = state.all.find(Stock => Stock.id === id);
    Stock.inventory--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
